"use strict";

const { String } = require("../lib/types");
const { makeNoLabel } = require("../lib/build-spec");

module.exports = {
  ADHave: makeNoLabel(
    String,
    "ADHave",
    "Does the patient have an advanced directive?"
  ),
  ADNarusCopy: makeNoLabel(
    String,
    "ADNarusCopy",
    "Has Narus Health received a copy of the advanced directive?"
  ),
  ADChanges: makeNoLabel(
    String,
    "ADChanges",
    "Does the patient need to make changes to the advanced directive?"
  ),
  ADCopies: makeNoLabel(
    String,
    "ADCopies",
    "Does the patient have copies of the advanced directive?"
  ),
  ADQuestions: makeNoLabel(
    String,
    "ADQuestions",
    "Does the patient have any questions about the advanced directive?"
  ),
  ADSendCopies: makeNoLabel(
    String,
    "ADSendCopies",
    "Do we need to send copies of the advanced directive to the medical team?"
  ),
  ADLearning: makeNoLabel(
    String,
    "ADLearning",
    "Is the patient interested in learning more about an advanced directive?"
  ),
  ADComplete: makeNoLabel(
    String,
    "ADComplete",
    "Does the patient want to complete an advanced directive?"
  ),
  DNRHave: makeNoLabel(String, "DNRHave", "Does the patient have a DNR?"),
  DNRNarusCopy: makeNoLabel(
    String,
    "DNRNarusCopy",
    "Has Narus Health received a copy of the DNR?"
  ),
  DNRChanges: makeNoLabel(
    String,
    "DNRChanges",
    "Does the patient need to make changes to the DNR?"
  ),
  DNRCopies: makeNoLabel(
    String,
    "DNRCopies",
    "Does the patient have copies of the DNR?"
  ),
  DNRQuestions: makeNoLabel(
    String,
    "DNRQuestions",
    "Does the patient have any questions about the DNR?"
  ),
  DNRSendCopies: makeNoLabel(
    String,
    "DNRSendCopies",
    "Do we need to send copies of the DNR to the medical team?"
  ),
  DNRLearning: makeNoLabel(
    String,
    "DNRLearning",
    "Is the patient interested in learning more about a DNR?"
  ),
  DNRComplete: makeNoLabel(
    String,
    "DNRComplete",
    "Does the patient want to complete a DNR?"
  ),
  LWHave: makeNoLabel(String, "LWHave", "Does the patient have a living will?"),
  LWNarusCopy: makeNoLabel(
    String,
    "LWNarusCopy",
    "Has Narus Health received a copy of the living will?"
  ),
  LWChanges: makeNoLabel(
    String,
    "LWChanges",
    "Does the patient need to make changes to the living will?"
  ),
  LWCopies: makeNoLabel(
    String,
    "LWCopies",
    "Does the patient have copies of the living will?"
  ),
  LWQuestions: makeNoLabel(
    String,
    "LWQuestions",
    "Does the patient have any questions about the living will?"
  ),
  LWSendCopies: makeNoLabel(
    String,
    "LWSendCopies",
    "Do we need to send copies of the living will to the medical team?"
  ),
  LWLearning: makeNoLabel(
    String,
    "LWLearning",
    "Is the patient interested in learning more about a living will?"
  ),
  LWComplete: makeNoLabel(
    String,
    "LWComplete",
    "Does the patient want to complete a living will?"
  ),
  PPHave: makeNoLabel(
    String,
    "PPHave",
    "Does the patient have a POST / POLST?"
  ),
  PPNarusCopy: makeNoLabel(
    String,
    "PPNarusCopy",
    "Has Narus Health received a copy of the POST / POLST?"
  ),
  PPChanges: makeNoLabel(
    String,
    "PPChanges",
    "Does the patient need to make changes to the POST / POLST?"
  ),
  PPCopies: makeNoLabel(
    String,
    "PPCopies",
    "Does the patient have copies of the POST / POLST?"
  ),
  PPQuestions: makeNoLabel(
    String,
    "PPQuestions",
    "Does the patient have any questions about the POST / POLST?"
  ),
  PPSendCopies: makeNoLabel(
    String,
    "PPSendCopies",
    "Do we need to send copies of the POST / POLST to the medical team?"
  ),
  PPLearning: makeNoLabel(
    String,
    "PPLearning",
    "Is the patient interested in learning more about a POST / POLST?"
  ),
  PPComplete: makeNoLabel(
    String,
    "PPComplete",
    "Does the patient want to complete a POST / POLST?"
  )
};
